import React from 'react';
import renderer from 'react-test-renderer';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import createHistory from 'history/createMemoryHistory';
import { connectRoutes } from 'redux-first-router';

// This is required for testing components which contain the redux-first-router Link component.
const history = createHistory();
const { middleware, enhancer, reducer } = connectRoutes(history, {
  'HOME': '/home',
});
const middlewares = applyMiddleware(middleware);
const enhancers = compose(enhancer, middlewares);
const rootReducer = (state = {}, action = {}) => ({
  location: reducer(state.location, action)
});
const store = createStore(rootReducer, enhancers);

export const provideMockedStore = component => (
  <Provider store={store}>
    {component}
  </Provider>
);



// WEBPACK FOOTER //
// ./services/test/provideMockedStore.js